<div *ngIf="render" id="upload-dl-container">
  <div class="self-tour-step-header justify-self-start font-denim-semibold text-xl"><h5>UPLOAD YOUR DRIVER'S LICENSE</h5></div>
  <div id="upload-dl-file-container" class="upload-dl-file-container-padding bg-beige-tricon w-full sm:w-1/3 h-full justify-self-center self-center rounded " (click)="uploadClick()" [ngClass]="{'bg-opacity-0': dlFile !== null || currentDLSource !== null }">
    <div *ngIf="dlFile === null && currentDLSource === null" id="upload-dl-placehold-cont" class="self-center row-span-2">
      <div id="upload-dl-icon"><i class="material-icons">
        camera_alt
        </i></div>
      <div id="upload-dl-selectfile">Click to Upload</div>
    </div>
    <div *ngIf="dlFile !== null || currentDLSource !== null" id="upload-dl-image-cont" class="self-center row-span-2">
      <div><img id="uploadedDLImage" [src]="currentDLSource"></div>
    </div>
    <input type="file" name="dlfile" id="dlfile" (change)="readUpload($event)" />
  </div>

  <div *ngIf="!isLoading" class="flex justify-end">
    <div class="w-full sm:w-1/4">
      <div class="grid col-gap-1">
        <button mat-flat-button color="accent" (click)="onSubmit()" [disabled]="dlFile === null || isLoading">NEXT</button>
    </div>
  </div>
</div>
  <div *ngIf="isLoading" class="flex justify-center"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>
</div>
